import { fetchSendMailHistory, sendMail, fetchSendMailHistoryById, sendSendMailStatus } from '../api/serveraccess'


export default function (){

  const updateStatus = async( id, status, callback ) => {
    try{
      await sendSendMailStatus( id, status )
      callback("success", id, status)
    }catch(e){
      callback(e)
    }  
  }


  const getSendMailHistory = async( callback ) => {
    try{
      var sendMailHistoryList = await fetchSendMailHistory()
      callback("success", sendMailHistoryList)
    }catch(e){
      callback(e)
    }
  }
  
  const getSendMailHistoryById = async( id, callback ) => {
    try{
      var sendMailHistory = await fetchSendMailHistoryById( id )
      callback("success", sendMailHistory)
    }catch(e){
      callback(e)
    }
  }
  
  const sendMailToUsers =async( title, message, callback )=>{
    try{
      var result = await sendMail( title, message )
      var results = result.split("@")
      callback(results[0], results[1])
    }catch(e){
      callback(e)
    }
  }
  return{
    getSendMailHistory,
    sendMailToUsers,
    getSendMailHistoryById,
    updateStatus
  }
}